import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import SendPasswordPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const store = getStore();

const createSendPasswordScreen = () => {
  const root = createRoot(document.getElementById('sendPasswordPanel'));
  if (isSupportedBrowser()) {
    root.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <SendPasswordPanel />
        </AuthScreenLayout>
      </Provider>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createSendPasswordScreen = createSendPasswordScreen;
